import { isDefined } from '@aloft/toolkit-shared';

export const getBundleFromIndex = (document: Document): string => {
  const localBundle = document.querySelector('#bundle')?.getAttribute('src');

  if (localBundle) return localBundle;

  const scriptTags = Array.from(document.querySelector('head')?.querySelectorAll('script') ?? []);
  const bundleSrc = scriptTags
    .find(
      (tag) =>
        tag.getAttribute('src')?.includes('/assets/index') &&
        isDefined(tag.getAttribute('crossorigin')) &&
        tag.getAttribute('type') === 'module',
    )
    ?.getAttribute('src');

  return bundleSrc ?? '';
};
